




















































































































































































































































































































































































































































































































import { TemplatesVue } from "fs-pb-vue2/vueModels/templates/TemplatesVue";
import { Component } from "vue-property-decorator";
import BackLink from "@/components/app/BackLink.vue";
import FsTemplateDialog from "@/components/templates/FsTemplateDialog.vue";

@Component({
  components: {
    BackLink,
    FsTemplateDialog
  }
})
export default class Templates extends TemplatesVue {

  displayTemplatePeriod(template: TemplateData ): string {
    return `${this.$options.filters.date(template.NextDate, 'datetime')} (${this.getPeriodText(
      template.Period
      )})`;
  }

  openTemplate(temp: TemplateData): void {
    if (temp && temp.IsActive && !this.editMode && !this.deleteMode) {
      this.toTemplateOperation(temp);
    }
  }

  get windowWidthCalc(): number {
    return window.innerWidth;
  }

  get combinedTemplates() {
    const isMobile = this.windowWidthCalc < 426;
    return isMobile ? [...this.simpleTemplates, ...this.periodTemplates] : [];
  }
}

